import { Injectable } from '@angular/core';
import { CultureCodes, CurrencyCodes } from '../../../../Autofacets-Core/src/app/utils/enums';
import { Features } from '../business-entities/step.class';
import { SettingDataService } from '../data-services/setting-data.service';

/**
 * Secure Storage Helper service
 */
@Injectable({
  providedIn: 'root'
})

export class SettingService {
  currency: string;
  features: Features[] = [];
  constructor(private settingDataService: SettingDataService) {
  }

  getCurrencyCode(cultureCode: string): string {
    let code = '';
    switch (cultureCode) {
      case CultureCodes.EN_US:
        code = CurrencyCodes.USD;
        break;
      case CultureCodes.NL_NL:
        code = CurrencyCodes.EUR;
        break;
      case CultureCodes.NB_NO:
        code = CurrencyCodes.NOK;
        break;
      case CultureCodes.FI_FI:
        code = CurrencyCodes.EUR;
        break;
      case CultureCodes.DE_DE:
        code = CurrencyCodes.EUR;
        break;
      default:
        code = CurrencyCodes.USD;
    }
    return code;
  }

  getFeatures(): Promise<any> {
    return this.settingDataService.getFeatures();
  }
  getGenericFeatures(): Promise<any> {
    return this.settingDataService.getGenericFeatures();
  }
  getFeaturesByDealerId(dealerId: string): Promise<any> {
    return this.settingDataService.getFeaturesByDealerId(dealerId);
  }
  async GetGenericSettings(): Promise<any> {
    return this.settingDataService.GetGenericSettings();
  }
  async GetSettings(): Promise<any> {
    return this.settingDataService.GetSettings();
  }

}
